import { AiOutlineDownload, AiOutlinePaperClip } from 'react-icons/ai';
import styled from 'styled-components';

import ActionLink from 'components/ActionLinks';
import { COLOR } from 'styles/styledComponents/color.model';

export const IconPaperClip = styled(AiOutlinePaperClip)`
  position: relative;
  color: ${COLOR.GUNSMOKE};
  font-size: 18px;
  top: 3px;
  margin-left: 0;
  margin-right: 7px;
  transition: 0.3s;
`;

export const DownloadIcon = styled(AiOutlineDownload)`
  margin-left: 46px;
  font-size: 18px;
  position: relative;
  top: 4px;
  opacity: 0;
  color: ${COLOR.GUNSMOKE};
  transition: 0.3s;
`;

export const DownloadActionLink = styled(ActionLink)`
  padding: 8px 18px 8px 6px;
  &:hover {
    background-color: ${COLOR.WHITE_SMOKE};

    & ${DownloadIcon} {
      opacity: 1;
      color: ${COLOR.CHEMISTRY};
    }

    & ${IconPaperClip} {
      color: ${COLOR.CHEMISTRY};
    }
  }
`;
